<template>
  <v-layout row wrap justify-start style="margin-top:5px">
    <v-flex shrink>
      <v-col>
        <button type="button" style="margin-right: 5px" v-bind:class="prevClass()" v-if="prevVisible" :disabled="prevDisabled" @click="emitPrevClickEvent">{{ prevText }}</button>
        <button type="button" style="margin-right: 5px" v-bind:class="cancelClass()" v-if="cancelVisible" :disabled="cancelDisabled" @click="emitCancelClickEvent">{{ cancelText }}</button>
        <button type="button" style="margin-right: 5px" v-bind:class="generateClass()" v-if="generateVisible" :disabled="generateDisabled" @click="emitGenerateClickEvent">{{ generateText }}</button>
        <button type="button" style="margin-right: 5px" v-bind:class="continueClass()" v-if="continueVisible" :disabled="continueDisabled" @click="emitContinueClickEvent">{{ continueText }}</button>
        <button type="button" style="margin-right: 5px" v-bind:class="finalClass()" v-if="finalVisible" :disabled="finalDisabled" @click="emitFinalClickEvent">{{ finalText }}</button>
      </v-col>
    </v-flex>

    <v-dialog v-model="cancelDialogOpen" width="500">
      <v-card>
        <v-card-title style="font-weight:bolder; font-size:smaller">{{ this.cancelText }}</v-card-title>
        <v-divider class="mx-4"></v-divider>
        <v-card-text>
          <br />
          <div class="text--primary">
            <p v-html="this.cancelDialogQuestion"></p>
          </div>
        </v-card-text>
        <v-card-actions>
          <button type="button" style="margin-right: 5px" class="btn btn-default" @click="closeDialog(true)">{{ this.cancelDialogYes }}</button>
          <button type="button" style="margin-right: 5px" class="btn btn-primary" @click="closeDialog(false)">{{ this.cancelDialogNo }}</button>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
  // WrsWizardStepButtons.vue

  export default {
    data() {
      return {
        cancelDialogOpen: false,
      }
    },
    props: {
      cancelText: {
        type: String,
        default: "Cancel"
      },
      cancelVisible: {
        type: Boolean,
        default: true
      },
      cancelDisabled: {
        type: Boolean,
        default: false
      },
      cancelButtonType: {
        type: String,
        default: 'B'
      },
      showCancelDialog: {
        type: Boolean,
        default: true
      },
      cancelDialogQuestion: {
        type: String,
        default: "Do you want to cancel?",
      },
      cancelDialogYes: {
        type: String,
        default: 'Yes'
      },
      cancelDialogNo: {
        type: String,
        default: "No"
      },

      generateText: {
        type: String,
        default: ""
      },
      generateVisible: {
        type: Boolean,
        default: false
      },
      generateDisabled: {
        type: Boolean,
        default: false
      },
      generateButtonType: {
        type: String,
        default: 'B'
      },

      continueText: {
        type: String,
        default: "Continue"
      },
      continueVisible: {
        type: Boolean,
        default: true
      },
      continueDisabled: {
        type: Boolean,
        default: false
      },
      continueButtonType: {
        type: String,
        default: 'B'
      },

      finalText: {
        type: String,
        default: "Final"
      },
      finalVisible: {
        type: Boolean,
        default: false
      },
      finalDisabled: {
        type: Boolean,
        default: true
      },
      finalButtonType: {
        type: String,
        default: 'P'
      },

      prevText: {
        type: String,
        default: "Previous"
      },
      prevVisible: {
        type: Boolean,
        default: false
      },
      prevDisabled: {
        type: Boolean,
        default: false
      },
      prevButtonType: {
        type: String,
        default: 'B'
      },
    },
    methods: {
      cancelClass: function () {
        return this.getClass(this.cancelButtonType);
      },
      generateClass: function () {
        return this.getClass(this.generateButtonType);
      },
      continueClass: function () {
        return this.getClass(this.continueButtonType);
      },
      finalClass: function () {
        return this.getClass(this.finalButtonType);
      },
      prevClass: function () {
        return this.getClass(this.prevButtonType);
      },

      getClass: function (bt) {
        var res = "btn btn-default wizardButton";
        if (bt == "P") {
          res = "btn btn-primary wizardButton";
        }

        return res;
      },


      emitCancelClickEvent: function () {
        if (this.showCancelDialog) {
          this.cancelDialogOpen = true;
        }
        else {
          this.$emit('cancelclicked');
        }
      },
      closeDialog: function (yesno) {
        this.cancelDialogOpen = false;
        if (yesno) {
          this.$emit('cancelclicked');
        }
      },
      emitGenerateClickEvent: function () {
        this.$emit('generateclicked');
      },
      emitContinueClickEvent: function () {
        this.$emit('continueclicked');
      },
      emitFinalClickEvent: function () {
        this.$emit('finalclicked');
      },
      emitPrevClickEvent: function () {
        this.$emit('prevclicked');
      },

    }
  }
</script>
